export const setHoverState = (hoverState) => (   
  {
    type: 'SET_HOVER',
    hoverState
  }
)

export const setHoverStateHt = (hoverStateht) => (   
  {
    type: 'SET_HOVERHT',
    hoverStateht
  }
)

export const setHoverStateHc = (hoverStatehc) => (   
  {
    type: 'SET_HOVERHC',
    hoverStatehc
  }
)

export const setHoverStateLc = (hoverStatelc) => (   
  {
    type: 'SET_HOVERLC',
    hoverStatelc
  }
)

export const setHoverStateCu = (hoverStatecu) => (   
  {
    type: 'SET_HOVERCU',
    hoverStatecu
  }
)

export const setClickStateUpDownShopAll = (clickStateUpDownShopAll) => (   
  {
    type: 'SET_CLICK_STATE_UP_DOWN_SHOPALL',
    clickStateUpDownShopAll
  }
)

export const setClickStateUpDownHouseHolds = (clickStateUpDownHouseHolds) => (   
  {
    type: 'SET_CLICK_STATE_UP_DOWN_HOUSEHOLDS',
    clickStateUpDownHouseHolds
  }
)

export const setClickStateUpDownMoreHouseHolds = (clickStateUpDownMoreHouseHolds) => (   
  {
    type: 'SET_CLICK_STATE_UP_DOWN_MORE_HOUSEHOLDS',
    clickStateUpDownMoreHouseHolds
  }
)

export const setClickStateUpDownRealEstate = (clickStateUpDownRealEstate) => (   
  {
    type: 'SET_CLICK_STATE_UP_DOWN_REALESTATE',
    clickStateUpDownRealEstate
  }
)

export const setClickStateUpDownPets = (clickStateUpDownPets) => (   
  {
    type: 'SET_CLICK_STATE_UP_DOWN_PETS',
    clickStateUpDownPets
  }
)

export const setClickStateUpSkilledLabour = (clickStateUpDownSkilledLabour) => (   
  {
    type: 'SET_CLICK_STATE_UP_DOWN_SKILLED_LABOUR',
    clickStateUpDownSkilledLabour
  }
)

export const setModalState = (modalStatus) => (   
  {
    type: 'SET_MODAL_STATE',
    modalStatus,
  }
)

export const setShopAllState = (shopAll) => (   
  {
    type: 'SET_SHOP_ALL_STATE',
    shopAll,
  }
)

export const setHouseHoldState = (houseHold) => (   
  {
    type: 'SET_HOUSEHOLD_STATE',
    houseHold,
  }
)

export const setMoreHouseHoldState = (moreHouseHold) => (   
  {
    type: 'SET_MORE_HOUSEHOLD_STATE',
    moreHouseHold,
  }
)

export const setRealEstateState = (realEstate) => (   
  {
    type: 'SET_REAL_ESTATE_STATE',
    realEstate,
  }
)

export const setSkilledLabourState = (skilledLabour) => (   
  {
    type: 'SET_SKILLED_LABOUR_STATE',
    skilledLabour,
  }
)

export const setPetState = (pet) => (   
  {
    type: 'SET_PET_STATE',
    pet,
  }
)

export const setOnDemandState = (onDemand) => (   
  {
    type: 'SET_ON_DEMAND_STATE',
    onDemand,
  }
)

export const setRecommendedState = (recommended) => (   
  {
    type: 'SET_RECOMMENDED_STATE',
    recommended,
  }
)

export const setLocationState = (location) => (   
  {
    type: 'SET_LOCATION_STATE',
    location,
  }
)

export const setContactState = (contact) => (   
  {
    type: 'SET_CONTACT_STATE',
    contact,
  }
)

export const setToggleAuthSetting = (toggleAuthSettings) => (   
  {
    type: 'SET_TOGGLE_AUTH_SETTINGS',
    toggleAuthSettings,
  }
)

export const setSearchModalState = (requestSearchClose) => (   
  {
    type: 'SET_SEARCH_SETTINGS',
    requestSearchClose,
  }
)

export const setCategories = (categories) => (   
  {
    type: 'SET_CATEGORIES',
    categories,
  }
)

export const setSingleCategory = (section) => (   
  {
    type: 'SET_SINGLE_CATEGORY',
    section,
  }
)


export const setWaitingState = (waitingStatus) => (   
  {
    type: 'SET_WAITING_STATUS',
    waitingStatus,
  }
)
